<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel"
    *ngIf="userType=='RECRUITER'|| userType=='MANAGEMENT_TALENT_ACQUISITION'|| userType=='FREELANCE_RECRUITER'">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>

    <ng-container *ngIf="candidatefilter =='false'&&!loadAPIcall|| candidatefilter==undefined&&!loadAPIcall">
      <div class="panel-heading hbuilt wig-c">
        {{ headerTitle }}
        <!-- Suggested Candidate -->
        <span style="float: right;cursor: pointer;" title="Refresh" data-toggle="tooltip"
          (click)="refereshSuggestedCandidate()"><ng-icon name="tablerRefresh"></ng-icon></span>
      </div>
      <div class="gs-sumo-match">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"/></svg>
        <span>Sumo AI · Matched to your active jobs</span>
      </div>
      <div class="panel-body no-padding">
        <div class="row">
          <div class="col-lg-12 pad-24px">
            <ul class="profile-list">
              <ng-container *ngIf="suggestionBehavior | async as response">
                <ng-container *ngIf="response!=null && response.length > 0">
                  <app-common-profile-info *ngFor="let item of response | slice:0:3" [userIdInput]="item.createdBy"
                    [page]="'CANDIDATES'" [data]="item" (click)="redirect(item)">
                    <ng-container headline1>{{item.firstName|titlecase}} {{item.lastName|titlecase}} </ng-container>
                    <div headline2 [title]="item.jobTitle"><span>{{item.jobTitle}}</span></div>
                    <div headline2 style="margin: 0px 0px 0px;" *ngIf="item?.matchingTitles!=null" [title]="item.matchingTitles">
                      <span>
                        Job title match:
                      </span>
                      <span title="{{item.matchingTitles}}">
                        {{item.matchingTitles}}
                      </span>
                    </div>
                    <div headline2 style="margin: 0px 0px 0px; " *ngIf="item?.matchingPrimarySkils!=null" [title]="item.matchingPrimarySkils">
                      <span>
                        Primary skill match:
                      </span>
                      <span title=" {{item.matchingPrimarySkils}}">
                        {{item.matchingPrimarySkils}}
                      </span>
                    </div>
                    <div headline2 style="margin: 0px 0px 0px;" *ngIf="item?.matchingSecondarySkils!=null" [title]="item.matchingSecondarySkils">
                      <span>
                        Secondary skill match :
                      </span>
                      <span title="{{item.matchingSecondarySkils}}">
                        {{item.matchingSecondarySkils}}
                      </span>
                    </div>
                  </app-common-profile-info>
                </ng-container>
                <button class="gs-743-more-btn" type="button"
                        *ngIf="response?.length > 0"
                        (click)="modelopen(response,false,'')">
                  View more →
                </button>
                <div class="gs-empty" *ngIf="response?.length == 0 || !response">
                  <span class="gs-empty-icon"><ng-icon name="tablerSparkles"></ng-icon></span>
                  <div class="gs-empty-title">No suggestions yet</div>
                  <div class="gs-empty-sub">Create jobs to get suggestions from the platform.</div>
                </div>
              </ng-container>
              <!-- <p *ngIf="suggestion==null||suggestion?.length==0"> No data Found </p> -->
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'" infiniteScroll
  [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">
  <div class="panel-body cardw">
    <div class="row">
      <div class="col-12">
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="10"
          [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="sugges!=null">
          <app-candidate-card [viewSize]="'large'" [candidateval]="sugges"
            [From]="'SUGGESTED_CANDIDATES'" [actionMenuEnabled]="true"></app-candidate-card>
        </div>

        <div class="col-md-12 padding-left-0 padding-right-5" *ngIf="(suggestionBehavior | async)?.length == 0 && !loadAPIcall">
          <div class="gs-empty">
            <span class="gs-empty-icon"><ng-icon name="tablerUserCircle"></ng-icon></span>
            <div class="gs-empty-title">No candidate suggestions yet</div>
            <div class="gs-empty-sub">Sorry, there are no candidate suggestions for you right now. Check back soon.</div>
          </div>
        </div>

        <div class="col-12" *ngIf="sugges==null && !loadAPIcall">
          <div class="col-md-12 padding-left-0 padding-right-5" *ngFor="let item of suggestionBehavior | async">
            <app-candidate-card [viewSize]="'large'" [candidateval]="item"
              [From]="'SUGGESTED_CANDIDATES'" [actionMenuEnabled]="true"></app-candidate-card>
          </div>

          <div class="col-sm-12 pl-1 end" *ngIf="stopScroll&&(suggestionBehavior | async)?.length>0"
            style="text-align: center; padding-top: 1rem;">
            <div class="col-sm-12">
              <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
              <ng-icon name="tablerCircleCheck"></ng-icon>

            </div>
            <div class="col-sm-12">
              <p class="biase">You've reached the bottom of the page</p>
            </div>
          </div>

          <!-- <div *ngIf="(suggestion | async) === null || (suggestion | async)?.length === 0 && !loadAPIcall">
            <p appQueryDOM [response]="resultContent" class="empty-message-container"
              style="float: right; position: relative; top: 150%; right: 32rem; bottom: -4rem; font-size: x-large;">
              <img src='assets/images/empty-page-picture.png' alt="">
              <span id="EmptyMessage" style="margin-top:-30px;" #empty class="empty-message">Fetching Marketplace Candidates...</span>
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>